import CopyToClipboard from './copy-to-clip'
import MainSearchInput from './main-search'
import SlideToggle from './slide-toggle'

CopyToClipboard.init()
MainSearchInput.init()
SlideToggle.init()
